import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import { getFormattedDate, getPaymentMethodLabel } from "src/helpers/helpers";
import ActionsCell from "./ActionsCell";
import { ExpenseType } from "./expenses-types";

const useExpensesTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Date",
      accessor: "date",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<ExpenseType>) => (
        <TextCell value={getFormattedDate(value)} />
      ),
    },
    {
      Header: "Category",
      accessor: "category",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Amount",
      accessor: "amount",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Payment Mode",
      accessor: "mode",
      className: "min-w-[180px]",
      Cell: ({ value }: CellProps<ExpenseType>) => {
        return <TextCell value={getPaymentMethodLabel(value)} />;
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<ExpenseType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useExpensesTableColumns;
